import { AppBar, Avatar, Box, ListItemButton, ListItemIcon, ListItemText, Stack, Tab, Tabs, TextField, Toolbar, Typography, useScrollTrigger } from '@mui/material'
import { Link } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import { Bell, UserCircle } from '@phosphor-icons/react'
import './style.css'
// import StudentRecord from './index'
import DoughnutChart from '../AdminDashboard/DoughnutChart'
import httpClient from '../../_util/api'
import Notifications from '../../shared/Notifications/Notification'
import Profile from '../../shared/Profile/Profile'
import StudentRecord from '../AdminDashboard'


const AlKauserAdmin = () => {
    const role = localStorage.getItem('role')
    const [value, setValue] = React.useState(0);
    const [noOfApplications,setNoOfApplications] = useState([])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const getNoOfApplications = async()=>{
        const res = await httpClient.get(role == "al-kauser Admin" ? '/students/noOfApplicationsAlKauserAdmin' : '/students/noOfApplications').catch((error)=>{
            console.log(error.message);
        })

        if(res?.status === 200){
            setNoOfApplications(res?.data)
        }
    }

    useEffect(()=>{
        getNoOfApplications()
    },[])


    return (
        <>

        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-around'} sx={{ width: '100%' }}>
            <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} sx={{ width: '6%' }}>
                <ListItemButton  >
                        <Notifications />
                </ListItemButton>

                <ListItemButton >
                    <ListItemIcon><Profile/></ListItemIcon>
                </ListItemButton>
            </Stack>
        </Stack>
            <Stack alignItems={'center'} justifyContent={'center'}>
                <Stack flexDirection={'row'} justifyContent={'space-between'}>
                    <Stack justifyContent={'space-between'} sx={{ width: '45%', height: '100%', backgroundColor: 'white', borderRadius: '6px' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            <Tab label="In Progress" />
                            <Tab label="Approved" />
                            <Tab label="Rejected" />
                            <Tab label="Returned Student"/>

                        </Tabs>
                        <Stack alignItems={'center'} sx={{ width: '100%' , height:'90%'}}>
                            <StudentRecord value={value}  screenName='Al Kauser Admin'/>
                        </Stack>
                    </Stack>

                    <Stack alignItems='center' justifyContent={'center'} sx={{ width: '26%', height: '50vh', backgroundColor: 'white', borderRadius: '6px' }}>
                        <Stack sx={{ width: '89%', height: '95%' }}>
                            <Typography sx={{ fontWeight: 'bold' }}>Applications To Review</Typography>
                            <Stack alignItems='center' justifyContent={'center'} sx={{height:'82%'}}>
                                <Typography variant='h1'>{noOfApplications[1]}</Typography>
                            </Stack>
                        </Stack>

                    </Stack>

                    <Stack alignItems={'center'} justifyContent={'space-around'} sx={{ width: '26%', height: '50vh', backgroundColor: 'white', borderRadius: '6px' }}>
                        <Stack sx={{ width: '89%', height: '95%' }}>
                            <Typography sx={{ fontWeight: 'bold' }}>Total Applications</Typography>
                            <Stack alignItems='center' justifyContent={'center'} sx={{height:'82%'}}>
                                <DoughnutChart chartData={noOfApplications} />
                            </Stack>
                        </Stack>
                    </Stack>

                </Stack>
            </Stack>
        </>
    )
}

export default AlKauserAdmin